import { useSample } from "@app/pages/samples/utils/useSample";
import { getCommonDefaultValues } from "../utils/getCommonDefaultValues";

export const getDefaultValuesAT = (defaultPreloadValues?: any) => {
  const { currentPreparationIndex, currentCounting, currentCalculation } =
    defaultPreloadValues;

  const commonValues = getCommonDefaultValues(defaultPreloadValues);
  const currentCountingIndex =
    currentPreparationIndex?.countings?.[currentCounting?.index as number];
  const currentCalculationIndex =
    currentCountingIndex?.calculations[currentCalculation?.index as number];

  const processingCurrent =
    useSample.getState().stateSample?.processing?.current || [];

  const dryingProcessing =
    processingCurrent && processingCurrent.length > 0
      ? processingCurrent.find((item) => item.processing_category?.id === 3)
      : undefined;

  return {
    ...commonValues,
    //preparation
    scintillator_lot_number:
      currentPreparationIndex?.scintillator_lot_number || undefined,
    mg_torta_end_limit: 26,
    planchette: currentPreparationIndex?.planchette || undefined,
    planchette_with_precipitate:
      currentPreparationIndex?.planchette_with_precipitate || undefined,
    //counting
    tiempo_muestra: "",
    total_cpm_sample: currentCountingIndex?.total_cpm_sample || "",
    counting_valid: "NA",
    counting_equipment: currentCountingIndex?.equipment || [],

    //calculation
    calculation_tsie_white: currentPreparationIndex?.mg_torta || undefined,
    calculation_tsie_sample:
      currentCalculationIndex?.sqp_tsie_sample || dryingProcessing?.wet_dry,
    calculation_total_cpm_sample: currentCountingIndex?.total_cpm_sample || "",
    calculation_detector: currentCountingIndex?.detectors || [],
    calculation_fondo: currentCalculationIndex?.fondos || undefined,
    calculation_equipment: currentCountingIndex?.equipment || [],
  };
};
